// extracted by mini-css-extract-plugin
export default {"tooltip":"fP-z","arrow":"gP-z"};